import React, { forwardRef } from "react";
import styles from "./button.module.css";

const Button = forwardRef((props, ref) => {
  return (
    <div className={styles.body}>
      <button
        ref={ref}
        className={styles.button1}
        onClick={props.onClick}
        type="button"
      >
        <div>{props.children}</div>
      </button>
    </div>
  );
});

export default Button;
